import { Center, Container, Loader } from '@mantine/core';
import styles from './PendingComponent.module.css';

export const PendingComponent: React.FC = () => {
  return (
    <Container className={styles.pendingComponentRoot}>
      <Center className={styles.pendingComponentContent}>
        <Loader color="blue" />
      </Center>
    </Container>
  );
};
